module.exports = __webpack_public_path__ + "static/media/not-notification.b5078c7d.webp";